import { render, staticRenderFns } from "./BackerCenterPledgesAndOrdersView.vue?vue&type=template&id=fe57de30"
import script from "./BackerCenterPledgesAndOrdersView.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgesAndOrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports